import Loadable from 'react-loadable';

import { type ProfileData } from '../ProfileKudos/lazy';

export interface KudosProps {
	uuid: string;
	referrerProfile?: ProfileData;
}

const LazyKudosPage = Loadable({
	loader: () => import(/* webpackChunkName: "async-ptc_kudos-page" */ './index'),
	loading: () => null,
});
LazyKudosPage.displayName = 'lazy(KudosPage)';

export default LazyKudosPage;
